"use strict";

$(function () {
  // お客様の声
  //--------------------------------------------
  $("#slider").slick({
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    slidesToShow: 3,
    variableWidth: true,
    prevArrow:
      '<div class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0641/7576/7770/files/prev.svg?v=1727927009" width="70" height="70"></div>',
    nextArrow:
      '<div class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0641/7576/7770/files/next.svg?v=1727927009" width="70" height="70"></div>',
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  // 商品詳細
  //--------------------------------------------
  $(".slick__main").slick({
    arrows: false,
    autoplay: true,
    asNavFor: ".slick__thumb",
  });
  // サムネイルのオプション
  $(".slick__thumb").slick({
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".slick__main",
    focusOnSelect: true,
  });
});
